import './inspiration.scss'

import {wrap} from '@codeurs/front'
import {InspirationChannelData} from 'campagne/types'
import React, {FunctionComponent} from 'react'
import {style} from 'util/campagne/style'
import {useTranslation} from 'util/i18n'
import {Layout} from 'views/campagne/layout'
import {BannerCta} from 'views/campagne/partials/banner'
import Blocks from 'views/campagne/partials/blocks'
import {CtaRegister} from 'views/campagne/partials/ctaregister'
import {Download} from 'views/campagne/partials/download'
import {FeaturedActions} from 'views/campagne/partials/featuredactions'
import {PracticalPromotion} from 'views/campagne/partials/practical'
import {Raster} from 'views/campagne/partials/raster'
import {Theme} from 'views/campagne/theme'

const styles = style('inspiration')

export const Inspiration: FunctionComponent<InspirationChannelData> = wrap(
	Layout
)(({blocks, practical_info, featured, cta, banner, downloads}) => {
	const t = useTranslation('campagne').inspiration
	return (
		<div class={styles}>
			<Theme.Container>
				<div class={styles('cols')}>
					{blocks && blocks.length > 0 && (
						<div class={styles('cols-blocks')}>
							<Blocks blocks={blocks} />
						</div>
					)}
					{practical_info && (
						<div class={styles('cols-info')}>
							<PracticalPromotion>
								<Theme.H3
									mod={['slantedtoleft', 'marked', 'white']}
									class={styles('cols-container-title')}
								>
									{t.practical}
								</Theme.H3>
								<div class={styles('cols-container-info')}>
									<Theme.Wysiwyg>{practical_info}</Theme.Wysiwyg>
								</div>
							</PracticalPromotion>
							{cta && (
								<div class={styles('cols-container-info-register')}>
									<CtaRegister mod="greyraster" {...cta} />
								</div>
							)}
						</div>
					)}
				</div>
				<Download {...downloads} />
			</Theme.Container>
			{featured && (
				<div class={styles('featured')}>
					<Raster>
						<Theme.Container>
							<FeaturedActions {...featured} />
						</Theme.Container>
					</Raster>
				</div>
			)}
			{banner && (
				<div class={styles('banner')}>
					<Theme.Container>
						<BannerCta
							headingLeft={banner.title1}
							headingRight={banner.title2}
							description={banner.text}
							ctaLink={banner.link}
							{...banner}
						/>
					</Theme.Container>
				</div>
			)}
		</div>
	)
})
